// User Role Enum matching backend
export enum UserRole {
  ADMIN = 'admin',
  MODERATOR = 'moderator',
  MEMBER = 'member',
}

// User interface matching backend API
export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  profilePicture?: string;
  phone?: string;
  isActive: boolean;
  role: UserRole;
  authSubId?: string;
  authProvider?: string;
  createdAt: string;
  updatedAt: string;
}

// Auth tokens interface
export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

// Auth state for Redux
export interface AuthState {
  user: User | null;
  tokens: AuthTokens | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

// Login request
export interface LoginCredentials {
  email: string;
  password: string;
}

// Register request
export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  profilePicture?: string;
  role?: UserRole;
}

// Common API Response format matching backend
export interface ApiResponse<T = unknown> {
  success: boolean;
  message: string;
  data: T | undefined;
  error: string | undefined;
  timestamp: string;
}

// Auth response data structure
export interface AuthResponseData {
  user: User;
  tokens: AuthTokens;
}

// Updatable user fields
export interface UpdateUserData {
  firstName?: string;
  lastName?: string;
  profilePicture?: string;
  phone?: string;
}

// Property address for a user (separate container, 1:N)
export interface UserProperty {
  id: string;
  userId: string;
  label: string;
  streetName?: string;
  houseNumber?: string;
  pinCode?: string;
  city?: string;
  state?: string;
  country?: string;
  isPrimary: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePropertyData {
  label: string;
  streetName?: string;
  houseNumber?: string;
  pinCode?: string;
  city?: string;
  state?: string;
  country?: string;
  isPrimary?: boolean;
}

export interface UpdatePropertyData {
  label?: string;
  streetName?: string;
  houseNumber?: string;
  pinCode?: string;
  city?: string;
  state?: string;
  country?: string;
  isPrimary?: boolean;
}

// Change password request
export interface ChangePasswordData {
  oldPassword: string;
  newPassword: string;
}

// Token refresh response data
export interface RefreshTokenResponseData {
  tokens: AuthTokens;
}

export interface ApiError {
  message: string;
  status: number;
  code?: string;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}
